import React from "react";

function SkillsCard() {
  return (
    <div
      className="skills-card-container"
      style={{
        background: "#fff",
        borderRadius: "28px",
        width: "680px",
        maxWidth: "98vw",
        boxShadow: "0 4px 24px rgba(80,80,120,0.13)",
        padding: "44px 38px 30px 38px",
        margin: "0 auto",
        marginBottom: "34px",
        marginTop: "12px",
        textAlign: "left",
      }}
    >
      <div
        style={{
          fontSize: "27px",
          fontWeight: 700,
          lineHeight: 1.18,
          marginBottom: "22px",
        }}
      >
        Skills & Expertise
      </div>

      <div style={{ marginBottom: "24px" }}>
        <div style={{ fontWeight: 600, marginBottom: "8px", fontSize: "15px" }}>
          <span role="img" aria-label="Frontend" style={{ marginRight: 7 }}>
            💻
          </span>
          Frontend Technologies
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "7px",
            marginBottom: 14,
          }}
        >
          {["React", "JavaScript", "HTML", "CSS", "Bootstrap"].map((tech) => (
            <span
              key={tech}
              style={{
                display: "inline-block",
                background: "#19191a",
                color: "#fff",
                borderRadius: "11px",
                fontSize: "13px",
                padding: "6px 12px",
                fontWeight: 500,
              }}
            >
              {tech}
            </span>
          ))}
        </div>

        <div style={{ fontWeight: 600, marginBottom: "8px", fontSize: "15px" }}>
          <span role="img" aria-label="Backend" style={{ marginRight: 7 }}>
            🛠️
          </span>
          Backend Technologies
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "7px",
            marginBottom: 14,
          }}
        >
          {["FastAPI", "NodeJS", "ExpressJS"].map((tech) => (
            <span
              key={tech}
              style={{
                display: "inline-block",
                background: "#19191a",
                color: "#fff",
                borderRadius: "11px",
                fontSize: "13px",
                padding: "6px 12px",
                fontWeight: 500,
              }}
            >
              {tech}
            </span>
          ))}
        </div>

        <div style={{ fontWeight: 600, marginBottom: "8px", fontSize: "15px" }}>
          <span role="img" aria-label="Database" style={{ marginRight: 7 }}>
            🗄️
          </span>
          Databases & Storage
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "7px",
            marginBottom: 14,
          }}
        >
          {["MySQL", "MongoDB"].map((tech) => (
            <span
              key={tech}
              style={{
                display: "inline-block",
                background: "#19191a",
                color: "#fff",
                borderRadius: "11px",
                fontSize: "13px",
                padding: "6px 12px",
                fontWeight: 500,
              }}
            >
              {tech}
            </span>
          ))}
        </div>

        <div style={{ fontWeight: 600, marginBottom: "8px", fontSize: "15px" }}>
          <span role="img" aria-label="Vector DB" style={{ marginRight: 7 }}>
            🧠
          </span>
          Vector Databases & RAG
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "7px",
            marginBottom: 14,
          }}
        >
          {["Qdrant", "mem0"].map((tech) => (
            <span
              key={tech}
              style={{
                display: "inline-block",
                background: "#19191a",
                color: "#fff",
                borderRadius: "11px",
                fontSize: "13px",
                padding: "6px 12px",
                fontWeight: 500,
              }}
            >
              {tech}
            </span>
          ))}
        </div>

        <div style={{ fontWeight: 600, marginBottom: "8px", fontSize: "15px" }}>
          <span role="img" aria-label="ML" style={{ marginRight: 7 }}>
            🤖
          </span>
          AI Frameworks
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "7px",
            marginBottom: 14,
          }}
        >
          {[
            "LangChain",
            "LangGraph",
            "Langsmith",
            "HuggingFace Transformers",
          ].map((tech) => (
            <span
              key={tech}
              style={{
                display: "inline-block",
                background: "#19191a",
                color: "#fff",
                borderRadius: "11px",
                fontSize: "13px",
                padding: "6px 12px",
                fontWeight: 500,
              }}
            >
              {tech}
            </span>
          ))}
        </div>

        <div style={{ fontWeight: 600, marginBottom: "8px", fontSize: "15px" }}>
          <span role="img" aria-label="Programming" style={{ marginRight: 7 }}>
            👨🏻‍💻
          </span>
          Cloud & Devops Tools
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "7px",
            marginBottom: 10,
          }}
        >
          {["AWS", "Docker", "Docker Compose", "Git/GitHub"].map((tech) => (
            <span
              key={tech}
              style={{
                display: "inline-block",
                background: "#19191a",
                color: "#fff",
                borderRadius: "11px",
                fontSize: "13px",
                padding: "6px 12px",
                fontWeight: 500,
              }}
            >
              {tech}
            </span>
          ))}
        </div>

        <div style={{ fontWeight: 600, marginBottom: "8px", fontSize: "15px" }}>
          <span role="img" aria-label="Programming" style={{ marginRight: 7 }}>
            💻
          </span>
          Programming Languages
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "7px",
            marginBottom: 10,
          }}
        >
          {["Python", "SQL", "JavaScript", "C++"].map((tech) => (
            <span
              key={tech}
              style={{
                display: "inline-block",
                background: "#19191a",
                color: "#fff",
                borderRadius: "11px",
                fontSize: "13px",
                padding: "6px 12px",
                fontWeight: 500,
              }}
            >
              {tech}
            </span>
          ))}
        </div>
      </div>

      <div
        style={{
          fontSize: "14px",
          color: "#15151e",
          marginTop: "18px",
          maxWidth: 610,
          lineHeight: 1.55,
        }}
      >
        <div style={{ marginBottom: "10px" }}>
          Alright, so for full-stack AI development, I'm pretty well-rounded.
        </div>
        <div style={{ marginBottom: "10px" }}>
          On the <span style={{ fontWeight: 600 }}>AI</span>, I'm solid with
          LangChain, LangGraph and Landsmith for building those complex agentic
          workflows, and I've got experience working with LLMs and building
          Multimodal RAG Pipelines.
        </div>
        <div style={{ marginBottom: "10px" }}>
          For the <span style={{ fontWeight: 600 }}>web development part</span>,
          I'm all about React for the frontend, and FastAPI or Node.js for the
          backend. Docker's my go-to for containerization.
        </div>
        <div style={{ marginBottom: "10px" }}>
          And when it comes to{" "}
          <span style={{ fontWeight: 600 }}>databases</span>, I've worked with
          MongoDB and MySQL, and of course, vector DBs like Qdrant for those RAG
          pipelines.
        </div>
        <div style={{ marginBottom: "10px" }}>
          For the <span style={{ fontWeight: 600 }}>Cloud & Devops</span>, I've
          worked with AWS services, Infact I am an AWS Certified Cloud
          Practitioner. Also well versed with the concepts of Docker, Docker
          compose & Devcontainers.
        </div>
        <div>
          Basically, I can handle things end-to-end, from the data and models to
          the UI and deployment. What part of that sounds most interesting to
          you?
        </div>
      </div>
    </div>
  );
}

export default SkillsCard;
